import { ActionTypes } from '../constants/index';

export const livestreaminfo = (payload: any) => ({
  type: ActionTypes.LIVE_STREAMING_INFO_LIST_REQUEST,
  payload,
});
